export const TEN_MINUTES_IN_MS = 600000;
